import { render, staticRenderFns } from "./myCertificate.vue?vue&type=template&id=b88dbffc&scoped=true&"
import script from "./myCertificate.vue?vue&type=script&lang=js&"
export * from "./myCertificate.vue?vue&type=script&lang=js&"
import style0 from "./myCertificate.vue?vue&type=style&index=0&id=b88dbffc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88dbffc",
  null
  
)

export default component.exports